*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  --wui-internal-glass-shadow: var(--wui-shadow-panel, 0 3px 9px rgb(0 0 0 / 0.27));
  display: block;
}

/* 容器模式：scrollTarget 为元素时按钮悬浮于容器底部（元素需置于容器内部），
   横向偏移沿用 --wui-back-top-left/right，纵向沿用 --wui-back-top-bottom */
:host([container-mode]) {
  position: sticky;
  bottom: var(--wui-back-top-bottom, 20px);
}

.back-top-inner {
  pointer-events: none;

  position: var(--wui-back-top-position, fixed);
  z-index: var(--wui-back-top-z-index, var(--wui-layer-auxiliary, 20));
  top: var(--wui-back-top-top, auto);
  right: var(--wui-back-top-right, 20px);
  bottom: var(--wui-back-top-bottom, 20px);
  left: var(--wui-back-top-left, auto);

  visibility: hidden;
  opacity: 0;

  .back-top-inner:focus-visible {
    border-radius: calc(infinity * 1px);
    outline: var(--wui-focus-ring-width, 3px) solid var(--wui-color-focus-ring, rgb(0 136 255 / 0.4));
    outline-offset: 2px;
  }
}

/* 容器模式下按钮脱离 fixed，改为流内布局并按偏移变量左/右对齐 */
:host([container-mode]) .back-top-inner {
  position: static;
  margin-right: var(--wui-back-top-right, 20px);
  margin-left: var(--wui-back-top-left, auto);
}

:host([visible]) .back-top-inner {
  pointer-events: auto;
  visibility: visible;
  opacity: 1;
}
